import { createReducer } from '@reduxjs/toolkit';
import {
  initialize,
  initializeSucceeded,
  setAllowUpgrade,
  setExternalSubscription,
  setExternalSubscriptionStatus,
  setExternalWebsiteId,
  setFeaturePermissions,
  setFeaturePermissionsStatus,
  setIntpWebsite,
  setIsFirstLogin,
  setPackages,
  setStpRates,
  setTheme,
} from '@va/aaas/shared/actions';
import {
  AaasBillingMode,
  AaasFeaturePermission,
  AdminTheme,
  AppState,
  DashboardType,
  GroupedPackages,
  StpCounterResponse,
} from '@va/aaas/shared/types';
import { apiStatus } from '@va/constants';
import { setDashboardType } from '@va/dashboard/actions/ui';
import { Website } from '@visitor-analytics/3as-sdk';

const appReducer = createReducer<AppState>(
  {
    initialized: false,
    intpWebsite: {} as (Website & { intpName: string; billingMode: AaasBillingMode }) | undefined,
    externalSubscription: { data: undefined, status: apiStatus.NONE },
    theme: undefined as AdminTheme | undefined,
    featurePermissions: {
      data: [] as AaasFeaturePermission[],
      status: apiStatus.NONE,
    },
    stpRates: {} as StpCounterResponse,
    allowUpgrade: false,
    externalWebsiteId: '',
    packages: {} as GroupedPackages,
    isFirstLogin: false,
    dashboardType: DashboardType.intpc,
  },
  (builder) => {
    builder.addCase(initialize, (state) => {
      state.initialized = true;
    });
    builder.addCase(initializeSucceeded, (state) => {
      state.initialized = true;
    });
    builder.addCase(setIntpWebsite, (state, action) => {
      state.intpWebsite = {
        ...action.payload,
        // @ts-ignore
        billingMode: action.payload.billingMode ?? AaasBillingMode.CompanyManaged,
      };
    });

    builder.addCase(setExternalSubscription, (state, action) => {
      state.externalSubscription.data = action.payload;
    });
    builder.addCase(setExternalSubscriptionStatus, (state, action) => {
      state.externalSubscription.status = action.payload;
    });
    builder.addCase(setTheme, (state, action) => {
      state.theme = action.payload;
    });
    builder.addCase(setFeaturePermissions, (state, action) => {
      state.featurePermissions.data = action.payload;
    });
    builder.addCase(setIsFirstLogin, (state, action) => {
      state.isFirstLogin = action.payload;
    });
    builder.addCase(setFeaturePermissionsStatus, (state, action) => {
      state.featurePermissions.status = action.payload;
    });
    builder.addCase(setStpRates, (state, action) => {
      state.stpRates = action.payload;
    });
    builder.addCase(setAllowUpgrade, (state, action) => {
      state.allowUpgrade = action.payload;
    });
    builder.addCase(setExternalWebsiteId, (state, action) => {
      state.externalWebsiteId = action.payload;
    });
    builder.addCase(setPackages, (state, action) => {
      state.packages = action.payload;
    });
    builder.addCase(setDashboardType, (state, action) => {
      state.dashboardType = action.payload;
    });
  },
);

export default appReducer;
